<template>
    <PageComponent 
        :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
        :addButtonLabel="addButtonLabel"
        @handleAddNew="addNewDocument"
        :searchFilters="searchFilters"
        @searchPage="searchDocuments"
        @resetFilters="resetFilters"
        @removeItem="removeDocument"
        @removeSelectedItems="removeDocuments"
        v-model:printModalVisible="printModalVisible"
        :printTitle="printTitle"
        :pdfUrl="pdfUrl"
        :addingRight="addingRight"
        :removingRight="removingRight"
        :rightsModule="rightsModule"
        :columns="tableColumns"
        :rows="documentsList"
        :actions="actions"
        :idField="idField"
        :groupingKey=true
        @handleSelectionChange="handleSelectionChange"
        @handleActionClick="handleActionClick"
        :count="depCount"
        :currentPage="currentPage"
        :result="depArrLen"
        @loadPrev="loadPrev"
        @loadNext="loadNext"
        @firstPage="firstPage"
        @lastPage="lastPage"
        :showNextBtn="showNextBtn"
        :showPreviousBtn="showPreviousBtn"
        :selectedValue="selectedValue"
        @selectSearchQuantity="selectSearchQuantity"
    />
    <MovableModal v-model:visible="depModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
        :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader"  @closeModal="closeModal">
        <DynamicForm 
            :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
            :displayButtons="displayButtons" @handleSubmit="createEmployeeDocument" @handleReset="handleReset" @file-changed="handleFileChange"
        />
    </MovableModal>
    <PrintModal v-model:visible="printModalVisible1" :title="printTitle" >
        <div v-if="imageUrl" class="w-full h-full flex items-center justify-center bg-gray-100">
            <img :src="imageUrl" class="max-w-[600px] max-h-[850px] object-contain shadow-lg rounded"  alt="Employee Document" />
        </div>
    </PrintModal>
</template>

<script>
import axios from "axios";
import { ref, computed, watch, onMounted, onBeforeMount } from 'vue';
import PageComponent from '@/components/PageComponent.vue'
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import PrintModal from '@/components/PrintModal.vue';


export default{
    name: 'Employee_Documents',
    components:{
        PageComponent,MovableModal,DynamicForm,PrintModal
    },
    setup(){
        const store = useStore();
        const toast = useToast();
        const loader = ref('');
        const modal_loader = ref('none');
        const memComponentKey = ref(0);
        const prodComponentKey = ref(0);
        const title = ref('Document Details');
        const addButtonLabel = ref('New Document');
        const addingRight = ref('Adding Employee Documents');
        const removingRight = ref('Deleting Employee Documents');
        const rightsModule = ref('HR');
        const idField = 'employee_document_id';
        const depModalVisible = ref(false);
        const printModalVisible = ref(false);
        const printModalVisible1 = ref(false);
        const pdfUrl = ref(null);
        const imageUrl = ref(null);
        const printTitle = ref('Print Employee Document');
        const documentsList = ref([]);
        const selectedIds = ref([]);
        const depResults = ref([]);
        const depArrLen = ref(0);
        const depCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('200px');
        const modal_left = ref('400px');
        const modal_width = ref('30vw');
        const upload_file = ref('');
        const filePath = ref('');
        const computedFilePath = ref('');
        const isEditing = computed(()=> store.state.Employee_Documents.isEditing)
        const selectedDocument = computed(()=> store.state.Employee_Documents.selectedDocument);
        const selectedEmployee = computed(()=> store.state.Employee_Documents.selectedEmployee);
        const employeeArray = computed(() => store.state.Employees.employeeArr);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Staff No", key: "staff_number"},
            {label: "Employee Name", key: "employee_name"},
            {label: "Document Type", key: "document_type"},
            {label: "Name", key: "document_name"},
        ])
        const actions = ref([
            {name: 'preview', icon: 'fa fa-paperclip', title: 'View Document', rightName: 'Adding Employee Documents'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Document', rightName: 'Deleting Employee Documents'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const employeeID = ref('');
        const category_search = ref('');
        const document_type_search = ref('');
        const name_search = ref('');
        const staff_number_search = ref("");
        const searchFilters = ref([
            {type:'text', placeholder:"Staff No...", value: staff_number_search, width:36,},
            {type:'text', placeholder:"Search Name...", value: name_search, width:48,},
            {
                type:'dropdown', placeholder:"Category..", value: category_search, width:40,
                options: [{text:'Identification',value:'Identification'},{text:'Employment',value:'Employment'},{text:'Payroll',value:'Payroll'},{text:'Education',value:'Education'},{text:'Compliance',value:'Compliance'},{text:'Medical',value:'Medical'},{text:'Performance',value:'Performance'},{text:'Exit',value:'Exit'},{text:'Other',value:'Other'}]
            },
            {
                type:'dropdown', placeholder:"Document Type..", value: document_type_search, width:40,
                options: [{text:'National ID',value:'National ID'},{text:'Passport',value:'Passport'},{text:'Birth Certificate',value:'Birth Certificate'},{text:'Driving License',value:'Driving License'},{text:'KRA PIN Certificate',value:'KRA PIN Certificate'},{text:'NSSF Certificate',value:'NSSF Certificate'},{text:'SHA Registration',value:'SHA Registration'},
                        {text:'Housing Levy Registration',value:'Housing Levy Registration'},{text:'Academic Certificate',value:'Academic Certificate'},{text:'Professional Certificate',value:'Professional Certificate'},{text:'Curriculum Vitae',value:'Curriculum Vitae'},{text:'Employment Contract',value:'Employment Contract'},{text:'Appointment Letter',value:'Appointment Letter'},{text:'Confirmation Letter',value:'Confirmation Letter'},
                        {text:'Promotion Letter',value:'Promotion Letter'},{text:'Transfer Letter',value:'Transfer Letter'},{text:'Warning Letter',value:'Warning Letter'},{text:'Performance Appraisal',value:'Performance Appraisal'},{text:'Training Certificate',value:'Training Certificate'},{text:'Medical Certificate',value:'Medical Certificate'},{text:'Medical Insurance Card',value:'Medical Insurance Card'},{text:'Payslip',value:'Payslip'},
                        {text:'Bank Statement',value:'Bank Statement'},{text:'Bank Details',value:'Bank Details'},{text:'Reference Letter',value:'Reference Letter'},{text:'Resignation Letter',value:'Resignation Letter'},{text:'Termination Letter',value:'Termination Letter'}
                ]
            },

        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchEmployees = async() =>{
            await store.dispatch('Employees/fetchEmployees', {company:companyID.value});
        };
        const handleSelectedEmployee = async(option) =>{
            await store.dispatch('Employees/handleSelectedEmployee', option)
            employeeID.value = store.state.Employees.employeeID;
        };
        const clearSelectedEmployee = async() =>{
            await store.dispatch('Employees/updateState', {employeeID: ''});
            employeeID.value = store.state.Employees.employeeID;
        };
        const formFields = ref([]);

        const employeeValue = computed(() => {
           return (selectedDocument.value && selectedDocument.value.employee && !employeeID.value) ? selectedDocument.value.employee.employee_id : employeeID.value;

        });
        const handleFileChange = (fileData) => {
            filePath.value = fileData.filePath;
            upload_file.value = fileData.file;

        };
        const updateDocName = (value) => {
            formFields.value[3].value = value;
        };
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Employee", value: employeeValue.value, componentKey: prodComponentKey,
                    selectOptions: employeeArray, optionSelected: handleSelectedEmployee, required: true,
                    searchPlaceholder: 'Select Employee...', dropdownWidth: '500px', updateValue: selectedEmployee.value,
                    clearSearch: clearSelectedEmployee
                },
                { type: 'dropdown', name: 'category',label: "Category", value: selectedDocument?.category || '', placeholder: "", required: true, options: [{ text: 'Identification', value: 'Identification' }, { text: 'Employment', value: 'Employment' }, { text: 'Payroll', value: 'Payroll' },{ text: 'Education', value: 'Education' }, { text: 'Compliance', value: 'Compliance' }, { text: 'Medical', value: 'Medical' }, { text: 'Performance', value: 'Performance' }, { text: 'Exit', value: 'Exit' }, { text: 'Other', value: 'Other' }] },
                { type: 'dropdown', name: 'document_type',label: "Type", value: selectedDocument?.document_type || '', placeholder: "", required: true, options: [{text:'National ID',value:'National ID'},{text:'Passport',value:'Passport'},{text:'Birth Certificate',value:'Birth Certificate'},{text:'Driving License',value:'Driving License'},{text:'KRA PIN Certificate',value:'KRA PIN Certificate'},{text:'NSSF Certificate',value:'NSSF Certificate'},{text:'SHA Registration',value:'SHA Registration'},
                        {text:'Housing Levy Registration',value:'Housing Levy Registration'},{text:'Academic Certificate',value:'Academic Certificate'},{text:'Professional Certificate',value:'Professional Certificate'},{text:'Curriculum Vitae',value:'Curriculum Vitae'},{text:'Employment Contract',value:'Employment Contract'},{text:'Appointment Letter',value:'Appointment Letter'},{text:'Confirmation Letter',value:'Confirmation Letter'},
                        {text:'Promotion Letter',value:'Promotion Letter'},{text:'Transfer Letter',value:'Transfer Letter'},{text:'Warning Letter',value:'Warning Letter'},{text:'Performance Appraisal',value:'Performance Appraisal'},{text:'Training Certificate',value:'Training Certificate'},{text:'Medical Certificate',value:'Medical Certificate'},{text:'Medical Insurance Card',value:'Medical Insurance Card'},{text:'Payslip',value:'Payslip'},
                        {text:'Bank Statement',value:'Bank Statement'},{text:'Bank Details',value:'Bank Details'},{text:'Reference Letter',value:'Reference Letter'},{text:'Resignation Letter',value:'Resignation Letter'},{text:'Termination Letter',value:'Termination Letter'}] , method: updateDocName},
                { type: 'text', name: 'document_name',label: "Name", value: selectedDocument.value?.document_name || '', required: true },
                { type: 'file', name: 'file-input',label: "Attachment", value: '', filePath: computedFilePath.value, required: false, placeholder: "", accepted_formats: "*/*", method: handleFileChange}
            ];
        };
        watch([selectedDocument, selectedEmployee], () => {
            if (selectedDocument.value && selectedEmployee.value) {
                prodComponentKey.value += 1;
                updateFormFields();
            }
            else{
                updateFormFields();
            }
        }, { immediate: true });
        const addNewDocument = () =>{
            depModalVisible.value = true;
            handleReset();
            store.dispatch("Employee_Documents/updateState",{selectedDocument:null, selectedEmployee:null,isEditing:false})
            flex_basis.value = '1/2';
            flex_basis_percentage.value = '50';
        };
        const previewDocument = (formData) =>{
            showLoader();
            axios
            .post("api/v1/preview-employee-document-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                        const contentType = response.headers["content-type"];
                        const blob = new Blob([response.data], {type: contentType});

                        const url = URL.createObjectURL(blob);

                        if (contentType === "application/pdf") {
                            pdfUrl.value = url;
                            imageUrl.value = null;
                            printModalVisible.value = true;
                        } else if (contentType.startsWith("image/")) {
                            imageUrl.value = url;
                            pdfUrl.value = null;
                            printModalVisible1.value = true;
                        }

                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'preview'){
                const docID = row['employee_document_id'];
                let formData = {
                    employee_document: docID,
                    company: companyID.value
                } 
                previewDocument(formData);
                
            }else if(action == 'delete'){
                const accountID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    employee_document: accountID,
                    user: userID.value,
                }
                await store.dispatch('Employee_Documents/deleteEmployeeDocument',formData).
                then(()=>{
                    searchDocuments();
                })
            }
        } 
        const handleReset = () =>{
            store.dispatch("Employee_Documents/updateState",{selectedDocument:null, selectedEmployee:null,isEditing:false})
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            prodComponentKey.value += 1;
            memComponentKey.value += 1;

        }
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createEmployeeDocument = async() =>{
            showModalLoader();
            let formData = new FormData();
            formData.append('category', formFields.value[1].value);
            formData.append('document_name', formFields.value[3].value);
            formData.append('document_type', formFields.value[2].value);
            formData.append('document_file', upload_file.value);
            formData.append('employee', employeeID.value);
            formData.append('employee_id', employeeID.value);
            formData.append('company', companyID.value);

            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type !='search-dropdown'){
                    errors.value.push('Error');
                }
            }
            if(employeeValue.value == ''){
                errors.value.push('Error');
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Employee_Documents/createEmployeeDocument', formData);
                    if(response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Document created successfully!');
                        handleReset();
                        memComponentKey.value += 1;
                        prodComponentKey.value += 1;
                    }else {
                        toast.error('An error occurred while creating the Document.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Document: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchDocuments();
                }
            }

        };
        const removeDocument = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    employee_document: selectedIds.value,
                    user: userID.value,
                }
                try{
                    const response = await store.dispatch('Employee_Documents/deleteEmployeeDocument',formData)
                    if(response && response.status == 200){
                        toast.success("Document Removed Succesfully");
                        searchDocuments();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Document: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Document") 
            }else{
                toast.error("Please Select A Document To Remove")
            }
        }
        const removeDocuments = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    employee_document: selectedIds.value,
                    user: userID.value,
                }
                try{
                    const response = await store.dispatch('Employee_Documents/deleteEmployeeDocument',formData)
                    if(response && response.status == 200){
                        toast.success("Document(s) Removed Succesfully");
                        searchDocuments();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Document(s): ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Document To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchDocuments = () =>{
            showLoader();
            showNextBtn.value = false;
            showPreviousBtn.value = false;
            let formData = {
                category: category_search.value,
                document_type: document_type_search.value,
                employee_name: name_search.value,
                staff_number: staff_number_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post(`api/v1/employee-documents-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                documentsList.value = response.data.results;
                store.commit('Employee_Documents/LIST_EMPLOYEE_DOCUMENTS', documentsList.value)
                depResults.value = response.data;
                depArrLen.value = documentsList.value.length;
                depCount.value = depResults.value.count;
                pageCount.value = Math.ceil(depCount.value / selectedValue.value);
                
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchDocuments(selectedValue.value);
        };
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchDocuments();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchDocuments();
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchDocuments();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchDocuments();
        }
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            name_search.value = "";
            category_search.value = "";
            document_type_search.value = "";
            staff_number_search.value = "";
            searchDocuments();
        };
        const closeModal = async() =>{
            depModalVisible.value = false;
            handleReset();
        }
        onMounted(()=>{
            searchDocuments();
            fetchEmployees();
        })
        return{
            title,idField, searchDocuments, addButtonLabel, searchFilters, resetFilters, tableColumns, documentsList,
            currentPage,depResults, depArrLen, depCount, pageCount, showNextBtn, showPreviousBtn,modal_top, modal_left, modal_width,
            loadPrev, loadNext, firstPage, lastPage, actions, formFields, depModalVisible, addNewDocument,
            displayButtons,flex_basis,flex_basis_percentage, handleActionClick, handleReset, createEmployeeDocument,
            showLoader, loader, hideLoader, modal_loader, showModalLoader, hideModalLoader, removeDocument, removeDocuments,
            addingRight,removingRight,rightsModule, closeModal,selectSearchQuantity,selectedValue,handleSelectionChange,
            handleFileChange,printModalVisible,printModalVisible1,pdfUrl,imageUrl, printTitle,
        }
    }
}
</script>